import {SWITCH_LANGUAGE, TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH, INDUSTRY_ASSET, SOURCE_ASSET, CLIENT_EVENTS_ASSET, LEAD_STATUS_ASSET, SERVICE_TYPE_ASSET } from "../../constants/ActionTypes";
import {LAYOUT_TYPE, NAV_STYLE, THEME_COLOR_SELECTION, THEME_TYPE} from "../../constants/ThemeSetting";


export function toggleCollapsedSideNav(navCollapsed) {
  return {type: TOGGLE_COLLAPSED_NAV, navCollapsed};
}

export function updateWindowWidth(width) {
  return (dispatch) => {
    dispatch({type: WINDOW_WIDTH, width});
  }

}

export function setThemeType(themeType) {
  return (dispatch) => {
    dispatch({type: THEME_TYPE, themeType});
  }
}

export function setThemeColorSelection(colorSelection) {
  return {type: THEME_COLOR_SELECTION, colorSelection};
}

export function onNavStyleChange(navStyle) {
  return (dispatch) => {
    dispatch({type: NAV_STYLE, navStyle});
  }
}

export function onLayoutTypeChange(layoutType) {
  return (dispatch) => {
    dispatch({type: LAYOUT_TYPE, layoutType});
  }
}

export function switchLanguage(locale) {
  return (dispatch) => {
    dispatch({
      type: SWITCH_LANGUAGE,
      payload: locale
    });
  }
}

export function setIndustries(data) {
  return {type: INDUSTRY_ASSET, data};
}

export function setSources(sources) {
  return {type: SOURCE_ASSET, sources};
}

export function setStatuses(leadStatusses) {
  return {type: LEAD_STATUS_ASSET, leadStatusses};
}

export function setServiceTypes(serviceTypes) {
  return {type: SERVICE_TYPE_ASSET, serviceTypes};
}

export function setClientEvents(clientEvents) {
  return {type: CLIENT_EVENTS_ASSET, clientEvents};
}